import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const addToBLTypesAdapter = getAdapter({ idFieldName: 'value' });

const addToBLTypesSlice = createSlice({
  name: 'addToBLTypes',
  initialState: addToBLTypesAdapter.getInitialState(),
  reducers: {
    setAddToBLTypes: (state, { payload: { addToBLTypes } }) => {
      addToBLTypesAdapter.setAll(state, addToBLTypes);
    },
  },
});

const selectors = addToBLTypesAdapter.getSelectors(({ addToBLTypes }) => addToBLTypes);

export const getAddToBLTypes = (state) => selectors.selectAll(state);

export const {
  setAddToBLTypes,
} = addToBLTypesSlice.actions;

export default addToBLTypesSlice.reducer;